export function getCurrentVIPCircle(state) {
    return state.VIPCircleReducer.vipcircles;
}

export function getSelectedVIPCircle(state) {
    let existing = state.VIPCircleReducer.vipcircles.filter(
        (x) => x._id === state.VIPCircleReducer.vipCircle._id
    );
    return existing.length > 0 ? existing[0] : state.VIPCircleReducer.vipCircle;
}

export function getUserVIPCircle(state) {
    return state.VIPCircleReducer.userVIPCircles;
}

export function getVIPSubscriptions(state) {
    return state.VIPCircleReducer.subscriptions;
}
